interface MessageProps {
  text: string | JSX.Element
  className?: string
}

const Message = ({ text, className = 'bg-red-900' }: MessageProps) => (
  <div
    className={`${className} w-full h-full py-1 px-[17px] text-white flex font-bold text-2xs justify-between rounded-lg`}
  >
    <div className='self-center'>
      <p className='text-2xs font-bold'>{text}</p>
    </div>
  </div>
)

export default Message
